import { useEffect, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useKBar } from "kbar";
import "../../style/global.css";
import SearchForm from "@components/Input/SearchForm/SearchForm";
import HeaderIcons from "../components/HeaderIcons/HeaderIcons";
import AccountSettings from "../../pages/AccountSettings/container";
import { FullNameTitle } from "../../styled";
import { ReactComponent as BurgerIcon } from "@assets/icon/burger.svg";
import { ReactComponent as MobileLogo } from "@assets/icon/logoMobile.svg";

import {
    DesktopMenuClick,
    HeaderContainer,
    HeaderSearchButtonWrapper,
    HeaderUserFullNameWrapper,
    HeaderUserInformationWrapper,
    HeaderUserPosition,
    HeaderUserSettingContainer,
    HeaderUserWrapper,
    InputIconWrapper,
    MbOpenClick,
    UserImageWrapper,
} from "../styled";
import ButtonIcon from "@components/Buttons/ButtonIcon/ButtonIcon";
import { IHeaderProps } from "../types";
import { useLastGlobalSearchQuery } from "Header/store/selector";

const Header = ({ setIsCollapsed, isCollapsed }: IHeaderProps) => {
    const name = localStorage.getItem("name");
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 575);
    const lastGlobalSearchQuery = useLastGlobalSearchQuery();
    const { query } = useKBar();

    const handleOpenKBar = (event?: React.FocusEvent) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        query.toggle();
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const role = localStorage.getItem("user_role");
    return (
        <HeaderContainer>
            <InputIconWrapper>
                <DesktopMenuClick>
                    <ButtonIcon
                        type="text"
                        icon={
                            isCollapsed ? (
                                <MenuUnfoldOutlined
                                    width={20}
                                    height={20}
                                    style={{
                                        fontSize: "20px",
                                        color: "var(--header-icons)",
                                    }}
                                />
                            ) : (
                                <MenuFoldOutlined
                                    width={20}
                                    height={20}
                                    style={{
                                        fontSize: "20px",
                                        color: "var(--header-icons)",
                                    }}
                                />
                            )
                        }
                        onClick={() => setIsCollapsed(isPrev => !isPrev)}
                        className="Mb_btn"
                    />
                </DesktopMenuClick>
                <MbOpenClick>
                    <ButtonIcon
                        type="text"
                        icon={<BurgerIcon width={18} height={24} color="var(--header-icons)" />}
                        onClick={() => setIsCollapsed(isPrev => !isPrev)}
                    />
                </MbOpenClick>
            </InputIconWrapper>
            <HeaderUserInformationWrapper>
                <HeaderSearchButtonWrapper onClick={() => handleOpenKBar()}>
                    <SearchForm value={lastGlobalSearchQuery} />
                </HeaderSearchButtonWrapper>

                {isMobile && <MobileLogo height="22px" color="var(--logo-hat-color)" />}

                <HeaderIcons isMobile={isMobile} />

                <HeaderUserWrapper>
                    <HeaderUserFullNameWrapper>
                        <FullNameTitle> {name} </FullNameTitle>
                        <HeaderUserPosition align="left">{role}</HeaderUserPosition>
                    </HeaderUserFullNameWrapper>

                    <UserImageWrapper src={"/images/default.webp"} alt="User Image" />
                    <HeaderUserSettingContainer>
                        {/* <Icon icon={ArrowDown} size="sm" /> */}
                        <AccountSettings />
                    </HeaderUserSettingContainer>
                </HeaderUserWrapper>
            </HeaderUserInformationWrapper>
        </HeaderContainer>
    );
};

export default Header;
